import { render, staticRenderFns } from "./tabPane.vue?vue&type=template&id=ee8ee042&scoped=true"
import script from "./tabPane.vue?vue&type=script&lang=js"
export * from "./tabPane.vue?vue&type=script&lang=js"
import style0 from "./tabPane.vue?vue&type=style&index=0&id=ee8ee042&prod&lang=scss&scoped=true"
import style1 from "./tabPane.vue?vue&type=style&index=1&id=ee8ee042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8ee042",
  null
  
)

export default component.exports